'use es6';

import UIButton from 'UIComponents/button/UIButton';
import styled from 'styled-components';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
export default styled(UIButton).withConfig({
  displayName: "StyleProtectedTransparentButton",
  componentId: "sc-1lmtzr4-0"
})(["color:", " !important;background-color:transparent !important;padding-left:5px !important;padding-right:5px !important;font-size:13px !important;margin-bottom:1px !important;"], CALYPSO_DARK);